import { TenantStatus } from '@servicetitan/marketing-tenant-management-api';
import { QueryParamsHandler, StringParamParser } from '@servicetitan/react-hooks';

export type TenantsQueryParams = Partial<{
    page: number;
    search: string;
    sortField: string;
    partners: string[];
    isAscending: boolean;
    statuses: TenantStatus[];
}>;

const statusesParser: StringParamParser<TenantStatus> = {
    stringify(value) {
        return value;
    },
    parse(query: TenantStatus) {
        if (Object.values(TenantStatus).includes(query)) {
            return query;
        }
    },
};

const pageParser: StringParamParser<number> = {
    stringify(value) {
        return value > 1 ? value.toString() : undefined;
    },
    parse(query) {
        const value = parseInt(query, 10);

        return Number.isNaN(value) || value <= 1 ? undefined : value;
    },
};

export const tenantsQueryParamsHandler = new QueryParamsHandler<TenantsQueryParams>({
    search: QueryParamsHandler.parserString,
    sortField: QueryParamsHandler.parserString,
    isAscending: QueryParamsHandler.parserBoolean,
    partners: QueryParamsHandler.parserStringArray,
    page: QueryParamsHandler.querySingleParam(pageParser),
    statuses: QueryParamsHandler.queryArrayParam(statusesParser),
});
